/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Typography from '../../components/Typography';
import { imageRoot } from '../../../env.config';
import Image from '../../components/Image';

const styles = theme => ({
  memberTestimonialsContainer: {
    background: `url(${imageRoot}/homepage/pattern2.png) #f9f9f9`,
    padding: '80px 20px',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      padding: '4rem 2rem'
    },
    [theme.breakpoints.down('xs')]: {
      padding: '2rem 1rem'
    }
  },
  memberTestimonialsContent: {
    padding: '0 5rem',
    textAlign: 'center',
    margin: '0 auto',
    [theme.breakpoints.down('sm')]: {
      padding: '4rem 2rem'
    },
    [theme.breakpoints.down('xs')]: {
      padding: '2rem 1rem'
    }
  },
  memberTestimonialBody: {
    margin: '1rem auto',
    fontSize: '1rem',
    [theme.breakpoints.up('md')]: {
      maxWidth: '75%'
    }
  }
});

class MemberTestimonials extends React.Component {
  render() {
    // eslint-disable-next-line react/prop-types
    const { classes } = this.props;
    return (
      <div className={classes.memberTestimonialsContainer}>
        <div
          className={classes.memberTestimonialsContent}
          style={{ maxWidth: 1343 }}
        >
          <Image src="/pricingpage/quote-mark.svg" />
          <Typography
            variant="subtitle1"
            color="primary"
            bold
            style={{ margin: '1.5rem 0' }}
          >
            READ OUR TESTIMONIALS
          </Typography>
          <Typography variant="h2" italic style={{ fontSize: '1.8rem' }}>
            Our Members Love Us!
          </Typography>
          <Typography
            className={classes.memberTestimonialBody}
            variant="body1"
            color="secondary.dark"
          >
            I've been a DirectBuy member for eight years. We built an entire
            house and bought everything from exercise equipment to lighting
            fixtures and faucets at a really great price. The biggest thing we
            bought were all of our cabinets which I still get compliments on
            today...
          </Typography>
          <Typography
            variant="subtitle2"
            color="secondary.muted"
            bold
            style={{ margin: '2rem 0' }}
          >
            SINA, ATLANTA. GA
          </Typography>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(MemberTestimonials);
